import type { JSX } from 'react';

import { Loader } from '@change-corgi/design-system-legacy/components/progressiveDisclosure';

import { withPrefetchedData } from 'src/shared/prefetch';

import { prefetchPageContext, TopicSitemapPageContextProvider } from 'src/app/pages/topicSitemap/pageContext';
import type { TopicSitemapPagePrefetchedDataProps } from 'src/app/pages/topicSitemap/pageContext';

import { Layout } from '../layout';

import { TopicSitemapErrorHandler } from './ErrorHandler';

export const TopicSitemap = withPrefetchedData(
	function TopicSitemap({ prefetchedData }: TopicSitemapPagePrefetchedDataProps): JSX.Element {
		return (
			<TopicSitemapPageContextProvider
				prefetchedData={prefetchedData}
				errorHandler={TopicSitemapErrorHandler}
				loadingFallback={<Loader size="m" my={256} mx="auto" />}
			>
				<Layout />
			</TopicSitemapPageContextProvider>
		);
	},
	{
		prefetchName: __MODULE_HASH__,

		prefetchData: async (context) => prefetchPageContext(context),
	},
);
